// Analytics wrapper over gtag.js (GA4). The gtag loader + config live in
// public/index.html (measurement ID G-VCZ7B9N51V). This file keeps the
// `analytics` / `logEvent` exports so existing callers don't need to change.

type Gtag = (...args: unknown[]) => void;

const getGtag = (): Gtag | null =>
  typeof window !== "undefined" && typeof (window as { gtag?: Gtag }).gtag === "function"
    ? (window as unknown as { gtag: Gtag }).gtag
    : null;

// Truthy on the client so existing `if (analytics)` guards keep working.
const analytics: unknown = typeof window !== "undefined" ? {} : null;

const logEvent = (
  _analytics: unknown,
  eventName: string,
  eventParams?: { [key: string]: unknown }
) => {
  const gtag = getGtag();
  if (gtag) {
    gtag("event", eventName, eventParams || {});
  }
};

export { analytics, logEvent };
